import { MouseEventHandler, ReactNode } from "react";
import Button from "./Button";
import "./EventActionButton.css";

type EventActionButtonVariant = "primary" | "ghost" | "danger" | "nav" | "pill";

type EventActionButtonProps = {
  icon: ReactNode;
  label: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  variant?: EventActionButtonVariant;
  href?: string;
  className?: string;
  disabled?: boolean;
};

function joinClassNames(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export default function EventActionButton({
  icon,
  label,
  onClick,
  variant = "primary",
  href,
  className,
  disabled,
}: EventActionButtonProps) {
  const classes = joinClassNames("event-action-button", className);
  const content = (
    <>
      <span className="event-action-button-icon" aria-hidden="true">
        {icon}
      </span>
      <span>{label}</span>
    </>
  );

  if (href) {
    return (
      <Button variant={variant} className={classes} href={href}>
        {content}
      </Button>
    );
  }

  return (
    <Button
      type="button"
      variant={variant}
      className={classes}
      onClick={onClick}
      disabled={disabled}
    >
      {content}
    </Button>
  );
}
